"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var category_permission_manager_service_1 = require("../category-permission-manager.service");
var Subject_1 = require("rxjs/Subject");
var operators_1 = require("rxjs/operators");
var PermissionManagerDialogComponent = /** @class */ (function () {
    function PermissionManagerDialogComponent(kbService, currentLanguageProvider, categoryPermissionManagerService, dialogRef, data) {
        this.kbService = kbService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.categoryPermissionManagerService = categoryPermissionManagerService;
        this.dialogRef = dialogRef;
        this.metaCategories = [];
        this._destroy$ = new Subject_1.Subject();
        this.conditionPermission = __assign({}, data.permission);
        this.isAdd = !Boolean(data.permission.categorySystemName);
    }
    PermissionManagerDialogComponent.prototype.ngOnInit = function () {
        this.getCurrentLanguage();
        this.getMetaCategories();
    };
    PermissionManagerDialogComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next();
        this._destroy$.complete();
    };
    PermissionManagerDialogComponent.prototype.cancel = function () {
        this.dialogRef.close(null);
    };
    PermissionManagerDialogComponent.prototype.submit = function () {
        var validCat = this.validCategory();
        var validExp = this.validExpression();
        var validName = this.validName();
        if (validCat && validExp && validName) {
            if (this.isAdd) {
                this.createConditionalPermission();
            }
            else {
                this.updateConditionalPermission();
            }
        }
    };
    PermissionManagerDialogComponent.prototype.selectCategory = function (cat) {
        this.conditionPermission.categorySystemName = cat;
        this.validCategory();
    };
    PermissionManagerDialogComponent.prototype.validCategory = function () {
        if (this.conditionPermission.categorySystemName) {
            this._categoryNotFilled = false;
        }
        else {
            this._categoryNotFilled = true;
        }
        return !this._categoryNotFilled;
    };
    PermissionManagerDialogComponent.prototype.validName = function () {
        if (this.conditionPermission.name.getValue(this.currentLanguageId)) {
            this._nameNotFilled = false;
        }
        else {
            this._nameNotFilled = true;
        }
        return !this._nameNotFilled;
    };
    PermissionManagerDialogComponent.prototype.validExpression = function () {
        if (this.conditionPermission.expression) {
            this._expressionNotFilled = false;
        }
        else {
            this._expressionNotFilled = true;
        }
        return !this._expressionNotFilled;
    };
    PermissionManagerDialogComponent.prototype.createConditionalPermission = function () {
        var _this = this;
        this.categoryPermissionManagerService.createCategoryConditionalPermission(this.convertNameFieldToMap(this.conditionPermission))
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (res) {
            _this.conditionPermission.permissionKey = res;
            _this.dialogRef.close(_this.conditionPermission);
        });
    };
    PermissionManagerDialogComponent.prototype.updateConditionalPermission = function () {
        var _this = this;
        this.categoryPermissionManagerService.updateCategoryConditionalPermission(this.convertNameFieldToMap(this.conditionPermission))
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function () {
            _this.dialogRef.close(_this.conditionPermission);
        });
    };
    PermissionManagerDialogComponent.prototype.convertNameFieldToMap = function (data) {
        var newData = __assign({}, data);
        newData.name = {};
        newData.name[this.currentLanguageId] = data.name.getValue(this.currentLanguageId);
        return newData;
    };
    PermissionManagerDialogComponent.prototype.getMetaCategories = function () {
        var _this = this;
        this.kbService.getMainEntityMetaCategories()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (res) {
            _this.metaCategories = Array.from(res);
        });
    };
    PermissionManagerDialogComponent.prototype.getCurrentLanguage = function () {
        var _this = this;
        this.currentLanguageProvider.getCurrentLanguage()
            .pipe(operators_1.takeUntil(this._destroy$))
            .subscribe(function (res) {
            _this.currentLanguageId = res.getId();
        });
    };
    Object.defineProperty(PermissionManagerDialogComponent.prototype, "categoryNotFilled", {
        get: function () {
            return this._categoryNotFilled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PermissionManagerDialogComponent.prototype, "nameNotFilled", {
        get: function () {
            return this._nameNotFilled;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PermissionManagerDialogComponent.prototype, "expressionNotFilled", {
        get: function () {
            return this._expressionNotFilled;
        },
        enumerable: true,
        configurable: true
    });
    PermissionManagerDialogComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-permission-manager-dialog',
            styles: [require('./permission-manager-dialog.component.css')],
            template: require('./permission-manager-dialog.component.html'),
        }),
        __param(4, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [idm_kb_service_client_js_1.KbService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            category_permission_manager_service_1.CategoryPermissionManagerService,
            material_1.MatDialogRef, Object])
    ], PermissionManagerDialogComponent);
    return PermissionManagerDialogComponent;
}());
exports.PermissionManagerDialogComponent = PermissionManagerDialogComponent;
//# sourceMappingURL=permission-manager-dialog.component.js.map